import "./style.scss";
import { ErrorTemplate } from "../../components/error-template/error-template.comp";

const NotFound = () => {
    return (
        <ErrorTemplate
            title="404 Error"
            description="The requested URL was not found on this server"
        />
    );
};

export default NotFound;
